var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1135_116461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3541 6.02342L22.0986 1.63932L2.08356 6.4789L0.34688 12.3116L26.3541 6.02342Z",
    fill: "#1B459A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7573 19.5606L21.8819 21.0259L26.3541 6.02342L22.0986 1.63932L16.7573 19.5606Z",
    fill: "#1D55C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1621 19.9457L11.2956 23.5861L0.34688 12.3116L2.08356 6.4789L15.1621 19.9457Z",
    fill: "#1D55C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4305 29.5522C30.505 36.2221 24.4808 40.8607 17.9747 39.9117C11.4686 38.9627 6.94451 32.7847 7.87009 26.1149C8.79566 19.4428 14.8209 14.8076 21.3271 15.7578C27.8332 16.7068 32.3573 22.8813 31.4305 29.5534V29.5522Z",
    fill: "#1B55C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5462 29.1309C27.8475 34.1677 23.2986 37.6698 18.3851 36.9534C13.4728 36.237 10.0583 31.5718 10.7581 26.535C11.4568 21.4982 16.0046 17.9972 20.9169 18.7136C25.8304 19.43 29.2449 24.093 28.5462 29.1297V29.1309Z",
    fill: "#B3C4EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6431 32.3907L19.0711 32.3704L18.9855 25.0476L16.9856 25.0648L16.9715 23.8038C18.0472 23.5834 18.7942 23.2967 19.4721 22.8719L20.943 22.8599L21.0534 32.3537L23.1927 32.3353L23.212 33.9809L16.6624 34.0363L16.6431 32.3907Z",
    fill: "#1B55C9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0401 35.0268C18.5214 33.0085 25.552 27.3502 29.3457 20.7277C26.6697 16.6367 16.9468 11.5391 9.70873 21.0374C8.21354 23.4292 6.12539 29.8027 10.0401 35.0268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2271 23.0835C15.743 23.2545 14.4147 23.0794 14.1308 22.1729C13.8425 21.2827 14.7069 20.0013 16.191 19.8305C17.6729 19.6458 19.136 20.6646 19.4178 21.5571C19.7083 22.4612 18.709 22.899 17.2271 23.0835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.415 25.5115C12.8271 25.9006 12.2635 25.8409 12.093 25.3058C11.9233 24.7729 12.2112 23.9668 12.7991 23.5776C13.3855 23.1866 14.0412 23.3629 14.2101 23.8961C14.3813 24.431 14.0014 25.1204 13.415 25.5115Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1135_116461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.5619,
    height: 39.9165,
    fill: "white",
    transform: "translate(0 0.960938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.d200b0ee969eb47f8a4e.svg";
export { ForwardRef as ReactComponent };